window.fieldLengthDict = {
  MaRemark: {
    Description: 240
  },
  MaSupplier: {
    Name: 60,
    OtherName: 60
  }
};


// WEBPACK FOOTER //
// ./src/fieldLength.js